import React, { useContext } from 'react';
import { Divider, Grid, IconButton, Tooltip } from '@mui/material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EngineeringIcon from '@mui/icons-material/Engineering';
import SchemaIcon from '@mui/icons-material/Schema';
import { RootRouteMode, rootRouteModeVar, setRootRouteMode } from '@/router/reactiveRoutes';
import { useReactiveVar } from '@apollo/client/react';
import { BLUE } from '@/theme/palette';
import CurrentUserContext from '@/Contexts/CurrentUser';
import { AdminPanelSettings } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router';

type MenuItemType = {
  title: RootRouteMode
  icon: React.JSX.Element
  tooltip: string
}

const MENU_ITEMS: MenuItemType[] = [
  {
    title: 'manager',
    icon: <EngineeringIcon fontSize='small' />,
    tooltip: 'Load Manager Dashboard'
  },
  {
    title: 'scheduler',
    icon: <CalendarMonthIcon fontSize='small' />,
    tooltip: 'Load Scheduler'
  },
  {
    title: 'report',
    icon: <AssessmentIcon fontSize='small' />,
    tooltip: 'Create New Daily Report'
  },
  {
    title: 'funnel',
    icon: <SchemaIcon fontSize='small' />,
    tooltip: 'Load Funnel'
  },
]

const AppMenu: React.FC = () => {
  const mode = useReactiveVar(rootRouteModeVar);
  const { currentUser } = useContext(CurrentUserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const menuItems = currentUser?.isSuperAdmin
    ? [
      { title: 'super', icon: <AdminPanelSettings fontSize="small" />, tooltip: 'Load Super Admin Dashboard' },
    ]
    : MENU_ITEMS;

  return (
    <Grid container spacing={1}>
      {
        menuItems.map((item) =>
          <React.Fragment key={`app-menu-item-${item.title}`}>
            <Tooltip title={item.tooltip}>
              <IconButton
                onClick={() => {
                  if (location.pathname !== "/") navigate("/");
                  setRootRouteMode(item.title as RootRouteMode);
                }}
                sx={{
                  color: mode === item.title ? BLUE : 'white',
                  backgroundColor: mode === item.title ? 'white' : '',
                  borderRadius: 1,
                  '&:hover': {
                    color: mode === item.title ? BLUE : 'white',
                    backgroundColor: mode === item.title ? 'white' : '',
                  }
                }}
              >
                {item.icon}
              </IconButton>
            </Tooltip>
            <Divider orientation="vertical" flexItem sx={{ borderColor: 'white' }} />
          </React.Fragment>
        )
      }
    </Grid>
  );
};

export default AppMenu;
